import React from 'react';
import { connect } from 'react-redux';
import actions from '../../state/actions/multi-currency';
import MobileSlideUpModal from '../../components/modals/mobile-slide-up-modal';
import MultiCurrencyList from './multi-currency-list';

class MultiCurrencyMobileSelector extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, currencies, selectedCurrency, open } = this.props;
        const selectCurrency = currency => () => {
            dispatch(actions.setPreferredCurrency(currency.code));
            dispatch(actions.closeMultiCurrencyMobile());
        };
        const close = () => dispatch(actions.closeMultiCurrencyMobile());
        return (
            <MobileSlideUpModal
                wrappedComponent={
                    <MultiCurrencyList
                        currencies={currencies}
                        selectedCurrencyCode={
                            selectedCurrency ? selectedCurrency.code : null
                        }
                        onCurrencySelected={selectCurrency}
                    />
                }
                active={open}
                onBackgroundClick={close}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        currencies: state.initData.currencies,
        selectedCurrency: state.multiCurrency.preferredCurrency,
        open: state.multiCurrency.mobileOpen,
        ...ownProps
    };
};

export default connect(mapStateToProps)(MultiCurrencyMobileSelector);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-mobile-selector.jsx